import { render, staticRenderFns } from "./PlateMainChart.vue?vue&type=template&id=34eea634&scoped=true&"
import script from "./PlateMainChart.vue?vue&type=script&lang=js&"
export * from "./PlateMainChart.vue?vue&type=script&lang=js&"
import style0 from "./PlateMainChart.vue?vue&type=style&index=0&id=34eea634&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eea634",
  null
  
)

export default component.exports